import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
var proxyNotSupportedInBrowser = new Error("ProxyPolicy is not supported in browser environment");
export function getDefaultProxySettings(_proxyUrl) {
  return undefined;
}
export function proxyPolicy(_proxySettings) {
  return {
    create: function create(_nextPolicy, _options) {
      throw proxyNotSupportedInBrowser;
    }
  };
}
export var ProxyPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(ProxyPolicy, _BaseRequestPolicy);

  function ProxyPolicy(nextPolicy, options) {
    var _this;

    _classCallCheck(this, ProxyPolicy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProxyPolicy).call(this, nextPolicy, options));
    throw proxyNotSupportedInBrowser;
    return _this;
  }

  _createClass(ProxyPolicy, [{
    key: "sendRequest",
    value: function sendRequest(_request) {
      throw proxyNotSupportedInBrowser;
    }
  }]);

  return ProxyPolicy;
}(BaseRequestPolicy);